import { useEffect, useState } from 'react';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import Modal from '../../common/Modal';
import Input from '../../common/Input';
import { setToastsError, setToastsSuccess, setToastsWarning } from '../../../redux/actions/common';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ChangeRequestBase from './ChangeRequestBase';
import { getNotConfirmTable } from '../../tables/table';
import { ChangeRequestControllerService, PriceSearchRequest } from '../../../services';
import '../../../assets/css/pages/stores/change-request-approve.css';
import { apiValidationErrorHandler } from '../../../api/apiErrorHandler';
import { setLoader } from '../../../redux/actions/api';
import { clearErrors } from '../../../redux/actions/error';
import { discountValidation } from '../../../utils/helpers/validation';
import { setIsContinue } from '../../../redux/actions/modal';
import { setChangeRequestType } from '../../../redux/actions/storage';

const ChangeRequestApprove = () => {
    // 承認画面
    const confirmStatus = 'NOT_CONFIRM';

    const history = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();

    const storage = useSelector((state) => state.storage);
    const { isFreshness, changeRequestType, isCompetitor, isHead } = storage;

    const modal = useSelector((state) => state.modal);
    const { isContinue } = modal;

    useEffect(() => {
        dispatch(clearErrors());
        if (isHead) {
            dispatch(setChangeRequestType(PriceSearchRequest.changeRequestType.FLYER));
        }
    }, [location, dispatch]);

    const [state, setState] = useState({
        apiResponse: null,
        reload: new Date(),

        authorizerName: '',
        isShowModalApprove: false,
        isCheckApproveName: false,
        isPastStartDate: false,
    });
    const [selectedData, setSelectedData] = useState([]);

    const {
        apiResponse,
        reload,

        authorizerName,
        isShowModalApprove,
        isCheckApproveName,
        isPastStartDate,
    } = state;

    const handleOnChangeRemandReason = (id, value) => {
        const data = apiResponse?.data.map((item) => {
            if (item.id === id) {
                item.remandReason = value;
            }
            return item;
        });
        setApiResponse({ ...apiResponse, data });
    };

    const table = getNotConfirmTable(t, handleOnChangeRemandReason, isFreshness, isCompetitor, isHead);

    const setApiResponse = (response) => {
        setState((prevState) => ({
            ...prevState,
            apiResponse: response,
        }));
    };

    const isPastDate = (startDate) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const inputDate = new Date(startDate);

        return inputDate < today;
    };

    const [formData, setFormData] = useState(null);

    useEffect(() => {
        dispatch(clearErrors());
        if (isContinue) {
            dispatch(setIsContinue(false));
            setState((prevState) => ({
                ...prevState,
                isShowModalApprove: true,
            }));
        }
    }, [dispatch, isContinue, location]);

    const handleShowModal = async () => {
        dispatch(clearErrors());
        if (selectedData.length !== apiResponse.data.length && !isHead) {
            // すべてのデータがチェックされていない場合はエラーを表示
            dispatch(setToastsError(t('message.info.notify.confirm.registration')));
            return;
        }
        dispatch(setLoader(true));
        setState((prevState) => ({
            ...prevState,
            isPastStartDate: false,
        }));
        const requestData = selectedData.map((item) => {
            if (isPastDate(item.salesStartDate)) {
                setState((prevState) => ({
                    ...prevState,
                    isPastStartDate: true,
                }));
            }
            return item;
        });

        const checkData = requestData
            .filter((item) => item.confirmed)
            .map((item) => {
                return item;
            });

        if (!isHead) {
            for (const item of checkData) {
                try {
                    await ChangeRequestControllerService.validateUpdateChangeRequest(item.id);
                } catch (error) {
                    dispatch(setLoader(false));
                    apiValidationErrorHandler(dispatch, error, [{ ...item }]);
                    return;
                }
            }

            // 乖離チェック
            if (await discountValidation(dispatch, checkData, isFreshness)) {
                dispatch(setLoader(false));
                return;
            }
        }

        setState((prevState) => ({
            ...prevState,
            isShowModalApprove: true,
        }));
        dispatch(setLoader(false));
    };

    const handleSubmitModalApprove = () => {
        dispatch(setLoader(true));
        dispatch(clearErrors());
        const request = {
            changeRequestType: changeRequestType,
            authorizerName: authorizerName,
            changeRequestApproveRequests: selectedData.map((item) => {
                return {
                    id: item.id,
                    remandFlg: item.remand,
                    remandReason: item.remandReason,
                    prohibited: item.prohibited,
                    lowerLimit: item.lowerLimit,
                };
            }),
        };

        const remandData = selectedData
            .filter((item) => item.remand)
            .map((item) => {
                return item;
            });

        ChangeRequestControllerService.approve(request)
            .then((response) => {
                response.length === 0
                    ? dispatch(setToastsWarning('承認が完了しました。\n連携対象商品はありませんでした。'))
                    : dispatch(setToastsSuccess('承認が完了しました。'));
                setState((prevState) => ({
                    ...prevState,
                    isShowModalApprove: false,
                }));
                if (remandData.length > 0 && !isHead) {
                    history('/change-request/remand');
                } else {
                    handleChangeInput('reload', new Date());
                }
            })
            .catch((error) => {
                apiValidationErrorHandler(dispatch, error, selectedData, '承認が失敗しました。');
            })
            .finally(() => {
                setSelectedData([]);
                dispatch(setLoader(false));
            });
    };

    const handleCloseModalApprove = () => {
        setState((prevState) => ({
            ...prevState,
            isShowModalApprove: false,
            authorizerName: '',
        }));
    };

    const handleChangeInput = (field, value) => {
        setState((prevState) => ({
            ...prevState,
            [field]: value,
            ...(field === 'authorizerName' && { isCheckApproveName: true }),
        }));
    };

    return (
        <div className="confirm-registration-competitive">
            <div className="okc-inner">
                <ChangeRequestBase
                    table={table}
                    confirmStatus={confirmStatus}
                    apiResponse={apiResponse}
                    setApiResponse={setApiResponse}
                    formData={formData}
                    setFormData={setFormData}
                    reload={reload}
                    selectedData={selectedData}
                    setSelectedData={setSelectedData}
                />
                <div className="d-flex justify-content-end c-slide-top mb-5">
                    <Button
                        className="btn btn--primary btn-block"
                        onClick={handleShowModal}
                        children={<span className="btn-text">{t('button.admit')}</span>}
                    />
                </div>

                <Modal
                    size="sm"
                    isShow={isShowModalApprove}
                    onClose={handleCloseModalApprove}
                    isShowIconClose="true"
                    title={
                        isPastStartDate
                            ? t('confirm_registration_price.modal_confirm_start_date.title')
                            : t('confirm_registration_price.modal_confirm.title')
                    }
                    className="registration-edit-modal"
                    btnList={[
                        {
                            name: isPastStartDate
                                ? t('confirm_registration_price.modal_confirm_start_date.button_ok')
                                : t('confirm_registration_price.modal_confirm.button_ok'),
                            className: 'btn--primary',
                            onClick: () => handleSubmitModalApprove(),
                            disabled: !authorizerName,
                        },
                        {
                            name: isPastStartDate
                                ? t('confirm_registration_price.modal_confirm_start_date.button_return')
                                : t('confirm_registration_price.modal_confirm.button_cancel'),
                            className: 'btn--secondary',
                            onClick: () => handleCloseModalApprove(),
                            disabled: false,
                        },
                    ]}
                >
                    <p className="text-center">
                        {isPastStartDate
                            ? t('confirm_registration_price.modal_confirm_start_date.text_01')
                            : t('confirm_registration_price.modal_confirm.first_content')}
                    </p>
                    <p className="text-center">
                        {isPastStartDate
                            ? t('confirm_registration_price.modal_confirm_start_date.text_02')
                            : t('confirm_registration_price.modal_confirm.second_content')}
                    </p>
                    <p className="text-center">
                        {isPastStartDate
                            ? t('confirm_registration_price.modal_confirm_start_date.text_03')
                            : t('confirm_registration_price.modal_confirm.third_content')}
                    </p>
                    <div className="approval-name">
                        <div>
                            <Input
                                className="form-control form-control--input"
                                name="authorizerName"
                                type="text"
                                autocomplete="off"
                                maxLength="45"
                                placeholder={t('confirm_registration_price.modal_confirm_deleted_csv.approval_name.label')}
                                value={authorizerName}
                                onChange={(value) => handleChangeInput('authorizerName', value)}
                                style={{
                                    border: !authorizerName && isCheckApproveName ? '1px solid #eb2013 !important' : '',
                                    borderColor: !authorizerName && isCheckApproveName ? '#eb2013' : '',
                                }}
                            />
                            {!authorizerName && isCheckApproveName && (
                                <p className="okc-error mt-2 mb-0">
                                    {t('confirm_registration_price.modal_confirm_deleted_csv.approval_name.error_message')}
                                </p>
                            )}
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default ChangeRequestApprove;
